var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWebIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 32.609,
    viewBox: "0 0 31 32.609",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_40776",
    "data-name": "Group 40776",
    transform: "translate(1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40579",
    "data-name": "Group 40579"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_48183",
    "data-name": "Path 48183",
    transform: "translate(3.913)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36051",
    "data-name": "Path 36051",
    d: "M23.478,31.859H2.609A1.861,1.861,0,0,1,.75,30V2.609A1.861,1.861,0,0,1,2.609.75H16.948l8.389,7.422V30A1.861,1.861,0,0,1,23.478,31.859Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36052",
    "data-name": "Path 36052",
    d: "M2.609,1.5A1.11,1.11,0,0,0,1.5,2.609V30a1.11,1.11,0,0,0,1.109,1.109h20.87A1.11,1.11,0,0,0,24.587,30V8.51L16.663,1.5H2.609m0-1.5H17.232l8.855,7.834V30a2.609,2.609,0,0,1-2.609,2.609H2.609A2.609,2.609,0,0,1,0,30V2.609A2.609,2.609,0,0,1,2.609,0Z",
    fill: "#9facc2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_10859",
    "data-name": "Rectangle 10859",
    transform: "translate(0 11.439)",
    fill: "#3e5c98",
    stroke: "#fff",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25.739,
    height: 13.584,
    rx: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.5,
    y: -0.5,
    width: 26.739,
    height: 14.584,
    rx: 1.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "CSV",
    d: "M10.02-6.98,8.07,0H6.42L5.11-4.97,3.74,0,2.1.01.22-6.98h1.5L2.95-1.56,4.37-6.98H5.93L7.27-1.59,8.51-6.98Zm2.31,1.13V-4.1h2.35v1.11H12.33v1.85h2.65V0H10.93V-6.99h4.05v1.14Zm7.88,2.27a1.569,1.569,0,0,1,.97.59,1.723,1.723,0,0,1,.38,1.1,1.773,1.773,0,0,1-.275.985,1.831,1.831,0,0,1-.8.665A2.913,2.913,0,0,1,19.26,0H16.25V-6.98h2.88a2.987,2.987,0,0,1,1.225.23,1.744,1.744,0,0,1,.78.64,1.676,1.676,0,0,1,.265.93,1.591,1.591,0,0,1-.325,1.02A1.739,1.739,0,0,1,20.21-3.58ZM17.65-4.1h1.28a1.172,1.172,0,0,0,.77-.225.792.792,0,0,0,.27-.645.807.807,0,0,0-.27-.65,1.154,1.154,0,0,0-.77-.23H17.65Zm1.41,2.96a1.2,1.2,0,0,0,.8-.24.84.84,0,0,0,.285-.68.876.876,0,0,0-.3-.7,1.21,1.21,0,0,0-.81-.255H17.65v1.88Z",
    transform: "translate(1.86 21.724)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Path_48182",
    "data-name": "Path 48182",
    transform: "translate(20.452 -0.64)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36053",
    "data-name": "Path 36053",
    d: "M8.747,9.218H2.855A2.357,2.357,0,0,1,.5,6.863V1.709c.868.729,2.311,1.951,3.764,3.231A46.48,46.48,0,0,1,8.747,9.218Z",
    fill: "#9facc2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36054",
    "data-name": "Path 36054",
    d: "M7.6,8.718c-.689-.7-1.85-1.8-3.807-3.522C2.788,4.309,1.792,3.456,1,2.785V6.863A1.857,1.857,0,0,0,2.855,8.718H7.6m1.788,1H2.855A2.855,2.855,0,0,1,0,6.863V.64S10.969,9.718,9.393,9.718Z",
    fill: "#9facc2"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebIcon);
export default __webpack_public_path__ + "static/media/web-icon.1ab6147f3c2e7c08125f7df937576384.svg";
export { ForwardRef as ReactComponent };